/* =========================================================
   CariSpray PDP - Vanilla JS
   Gallery � Variants � Bundles � Qty � StickyATC � FAQ � BA
   ========================================================= */

(function () {
  'use strict';

  /* -------- Utility -------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* =========================================================
     ANNOUNCEMENT BAR - rotating messages
     ========================================================= */
  function initAnnouncement() {
    const msgs = $$('.cpdp-announcement__msg');
    if (msgs.length < 2) return;
    let i = 0;
    msgs.forEach((m, idx) => m.style.display = idx === 0 ? '' : 'none');
    setInterval(function () {
      msgs[i].style.opacity = '0';
      setTimeout(function () {
        msgs[i].style.display = 'none';
        i = (i + 1) % msgs.length;
        msgs[i].style.display = '';
        msgs[i].style.opacity = '0';
        requestAnimationFrame(function () {
          msgs[i].style.transition = 'opacity .4s ease';
          msgs[i].style.opacity = '1';
        });
      }, 300);
    }, 3800);
  }

  /* =========================================================
     GALLERY - prev/next + thumbnail click
     ========================================================= */
  function initGallery() {
    $$('.cpdp-gallery').forEach(function (gallery) {
      var items = $$('.cpdp-gallery-media', gallery);
      var thumbs = $$('.cpdp-thumb', gallery);
      var current = 0;

      function goTo(idx) {
        current = (idx + items.length) % items.length;
        items.forEach(function (el, i) {
          el.classList.toggle('is-active', i === current);
        });
        thumbs.forEach(function (el, i) {
          el.classList.toggle('is-active', i === current);
        });
      }

      var prev = $('.cpdp-gallery-nav--prev', gallery);
      var next = $('.cpdp-gallery-nav--next', gallery);
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });

      goTo(0);

      /* swipe support */
      var startX = 0;
      var main = $('.cpdp-gallery-main', gallery);
      if (main) {
        main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
        });
      }

      /* expose for variant switcher */
      gallery._cpdpGoTo = goTo;
      gallery._cpdpCurrent = function () { return current; };
    });
  }

  /* =========================================================
     VARIANT SWITCHER
     ========================================================= */
  function initVariants() {
    var productData = window.CPDP_PRODUCT;
    if (!productData) return;

    var variants = productData.variants || [];
    var form = $('#cpdp-form');
    if (!form) return;

    var variantInput = $('#cpdp-variant-id', form);
    var priceNow = $('.cpdp-price-now');
    var priceWas = $('.cpdp-price-was');
    var priceSave = $('.cpdp-price-save');
    var installmentEl = $('.cpdp-installments-amount');
    var atcBtn = form.querySelector('[name="add"]');
    var stickyPrice = $('.cpdp-sticky-price');

    function formatMoney(cents) {
      var symbol = productData.currencySymbol || '?';
      return symbol + (cents / 100).toFixed(2).replace('.', ',');
    }

    function selectVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;

      var price = variant.price;
      var compare = variant.compare_at_price;

      if (priceNow) priceNow.textContent = formatMoney(price);
      if (priceWas) {
        if (compare && compare > price) {
          priceWas.textContent = formatMoney(compare);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (priceSave && compare && compare > price) {
        var pct = Math.round((1 - price / compare) * 100);
        priceSave.textContent = 'SAVE ' + pct + '%';
        priceSave.style.display = '';
      } else if (priceSave) {
        priceSave.style.display = 'none';
      }
      if (installmentEl) {
        installmentEl.textContent = formatMoney(Math.round(price / 4));
      }
      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(price);
      }

      var available = variant.available;
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.textContent = available
          ? (atcBtn.dataset.addText || 'Add to cart')
          : (atcBtn.dataset.soldText || 'Sold out');
      }

      /* update gallery if variant has featured_image */
      if (variant.featured_image) {
        var gallery = document.querySelector('.cpdp-gallery');
        var items = gallery ? gallery.querySelectorAll('.cpdp-gallery-media') : [];
        items.forEach(function (item, idx) {
          var img = item.querySelector('img');
          if (img && img.src.includes(variant.featured_image.src.split('?')[0].split('/').pop().split('.')[0])) {
            if (gallery._cpdpGoTo) gallery._cpdpGoTo(idx);
          }
        });
      }
    }

    /* --- Option-based selector (swatches) --- */
    $$('.cpdp-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var optionIndex = parseInt(this.dataset.optionIndex, 10);
        var optionValue = this.dataset.optionValue;

        $$('.cpdp-swatch[data-option-index="' + optionIndex + '"]').forEach(function (s) {
          s.classList.remove('is-active');
        });
        this.classList.add('is-active');

        /* update displayed option label */
        var label = document.querySelector('[data-option-label="' + optionIndex + '"]');
        if (label) label.textContent = optionValue;

        /* find matching variant */
        var selected = getSelectedOptions();
        selected[optionIndex] = optionValue;

        var match = findVariant(variants, selected);
        if (match) selectVariant(match);
      });
    });

    function getSelectedOptions() {
      var opts = {};
      $$('.cpdp-swatch.is-active').forEach(function (s) {
        opts[parseInt(s.dataset.optionIndex, 10)] = s.dataset.optionValue;
      });
      return opts;
    }

    function findVariant(variants, selectedOpts) {
      return variants.find(function (v) {
        return Object.keys(selectedOpts).every(function (idx) {
          return v['option' + (parseInt(idx) + 1)] === selectedOpts[idx];
        });
      }) || variants[0];
    }

    /* --- Select dropdown (fallback) --- */
    var variantSelect = $('#cpdp-variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var variant = variants.find(function (v) { return v.id == this.value; }, this);
        if (variant) selectVariant(variant);
      });
    }

    /* Init with first available */
    var initial = variants.find(function (v) { return v.available; }) || variants[0];
    if (initial) selectVariant(initial);
  }

  /* =========================================================
     BUNDLE PICKER
     ========================================================= */
  function initBundles() {
    var cards = $$('.cpdp-bundle-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-active'); });
        this.classList.add('is-active');

        /* update main price display */
        var price = this.dataset.price;
        var compare = this.dataset.compare;
        var priceNow = document.querySelector('.cpdp-price-now');
        var priceWas = document.querySelector('.cpdp-price-was');
        var priceSave = document.querySelector('.cpdp-price-save');
        var installmentEl = document.querySelector('.cpdp-installments-amount');
        var stickyPrice = document.querySelector('.cpdp-sticky-price');

        if (priceNow && price) priceNow.textContent = price;
        if (priceWas && compare) {
          priceWas.textContent = compare;
          priceWas.style.display = '';
        }
        if (priceSave && this.dataset.savePct) {
          priceSave.textContent = 'SAVE ' + this.dataset.savePct + '%';
          priceSave.style.display = '';
        }
        if (installmentEl && this.dataset.installment) {
          installmentEl.textContent = this.dataset.installment;
        }
        if (stickyPrice && price) {
          stickyPrice.textContent = price;
        }

        /* if bundle has a linked variant ID, switch the form input */
        var variantId = this.dataset.variantId;
        var variantInput = document.querySelector('#cpdp-variant-id');
        if (variantId && variantInput) {
          variantInput.value = variantId;
        }

        /* if bundle sets quantity, update qty input */
        var bundleQty = this.dataset.bundleQty;
        var qtyInput = document.querySelector('.cpdp-qty-input');
        if (bundleQty && qtyInput) {
          qtyInput.value = bundleQty;
          qtyInput.dispatchEvent(new Event('change'));
        }
      });
    });

    /* activate first card by default */
    if (cards[0]) cards[0].click();
  }

  /* =========================================================
     QTY STEPPER
     ========================================================= */
  function initQty() {
    $$('.cpdp-qty').forEach(function (wrap) {
      var input = wrap.querySelector('.cpdp-qty-input');
      var dec = wrap.querySelector('[data-action="dec"]');
      var inc = wrap.querySelector('[data-action="inc"]');
      if (!input) return;

      function setVal(v) {
        input.value = Math.max(1, Math.min(99, v));
        input.dispatchEvent(new Event('change'));
        updateAtcTotal();
      }

      if (dec) dec.addEventListener('click', function () { setVal(parseInt(input.value) - 1); });
      if (inc) inc.addEventListener('click', function () { setVal(parseInt(input.value) + 1); });
      input.addEventListener('change', function () { setVal(parseInt(this.value) || 1); });

      /* keep hidden form quantity in sync */
      input.addEventListener('change', function () {
        var qtyHidden = document.querySelector('#cpdp-quantity');
        if (qtyHidden) qtyHidden.value = this.value;
      });
    });
  }

  function updateAtcTotal() {
    var atcBtn = document.querySelector('#cpdp-form [name="add"]');
    if (!atcBtn || !atcBtn.dataset.addText) return;
    /* price update handled by variant/bundle selectors */
  }

  /* =========================================================
     STICKY ATC - IntersectionObserver on hero
     ========================================================= */
  function initStickyATC() {
    var sticky = $('.cpdp-sticky-atc');
    if (!sticky) return;

    var hero = $('.cpdp-hero') || $('.cpdp-buybox');
    if (!hero) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      observer.observe(hero);
    } else {
      /* Fallback */
      window.addEventListener('scroll', function () {
        var rect = hero.getBoundingClientRect();
        sticky.classList.toggle('is-visible', rect.bottom < 0);
      }, { passive: true });
    }

    /* Clicking sticky ATC scrolls to hero buybox */
    var stickyBtn = sticky.querySelector('.cpdp-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var buybox = document.querySelector('.cpdp-buybox');
        if (buybox) {
          buybox.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  /* =========================================================
     FAQ ACCORDION - one open at a time
     ========================================================= */
  function initFAQ() {
    $$('.cpdp-faq').forEach(function (faqList) {
      var items = $$('.cpdp-faq-item', faqList);
      items.forEach(function (item, idx) {
        var btn = item.querySelector('.cpdp-faq-q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          /* close all */
          items.forEach(function (it) { it.classList.remove('is-open'); });
          /* re-open if was closed */
          if (!isOpen) item.classList.add('is-open');
        });
      });
      /* open first by default */
      if (items[0]) items[0].classList.add('is-open');
    });
  }

  /* =========================================================
     BEFORE / AFTER SLIDER
     ========================================================= */
  function initBeforeAfter() {
    $$('.cpdp-ba-wrap').forEach(function (wrap) {
      var dragging = false;

      function update(clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        wrap.style.setProperty('--cpdp-cut', pct + '%');
      }

      wrap.addEventListener('mousedown', function (e) { dragging = true; update(e.clientX); });
      document.addEventListener('mousemove', function (e) { if (dragging) update(e.clientX); });
      document.addEventListener('mouseup', function () { dragging = false; });

      wrap.addEventListener('touchstart', function (e) { dragging = true; update(e.touches[0].clientX); }, { passive: true });
      wrap.addEventListener('touchmove', function (e) { update(e.touches[0].clientX); }, { passive: true });
      wrap.addEventListener('touchend', function () { dragging = false; });
    });
  }

  /* =========================================================
     FORM SUBMISSION - prevent default, use fetch for cart
     ========================================================= */
  function initProductForm() {
    var form = document.getElementById('cpdp-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      if (btn && btn.disabled) return;

      var data = new FormData(form);
      if (btn) {
        var origText = btn.textContent;
        btn.textContent = 'Adding.';
        btn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (btn) {
          btn.textContent = 'Added!';
          setTimeout(function () {
            btn.textContent = origText;
            btn.disabled = false;
          }, 1800);
        }
        /* Trigger cart update event for theme drawer */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        if (btn) {
          btn.textContent = origText;
          btn.disabled = false;
        }
      });
    });
  }

  /* =========================================================
     INIT
     ========================================================= */
  function init() {
    initAnnouncement();
    initGallery();
    initVariants();
    initBundles();
    initQty();
    initStickyATC();
    initFAQ();
    initBeforeAfter();
    initProductForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
